import { gql } from "@apollo/client";

export default gql`
  query routineSkillOptions($organizationId: Int!) {
    mySkills {
      id
      name
      slug
      description
    }
    platformSkills(organizationId: $organizationId) {
      id
      name
      slug
      description
    }
    workspaceSkills(organizationId: $organizationId) {
      id
      name
      slug
      description
    }
  }
`;
